import { render, staticRenderFns } from "./AddAccessTab.vue?vue&type=template&id=92439a20&scoped=true"
import script from "./AddAccessTab.vue?vue&type=script&lang=js"
export * from "./AddAccessTab.vue?vue&type=script&lang=js"
import style0 from "./AddAccessTab.vue?vue&type=style&index=0&id=92439a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92439a20",
  null
  
)

export default component.exports